import React from "react";
import ModalComponent from "../../components/customComponents/ModalComponent/ModalComponent";

const PhoneSearchPopup = ({
  openModal,
  setOpenPhoneModal,
  setFormData,
  phoneSearchedUserData,
  setEmailAndPhone,
}) => {
  return (
    <>
      <ModalComponent
        openModal={openModal}
        onClose={() => setOpenPhoneModal(false)}
        modalId="PhoneSearchUser"
        mainheading="Phone Search Result"
        modalContent={
          phoneSearchedUserData?.data?.length > 0 && (
            <div className="p-3">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Parent Account</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {phoneSearchedUserData.data.map((user, index) => (
                    <tr key={index}>
                      <td>{user?.firstName}</td>
                      <td>{user?.lastName}</td>
                      <td>{user?.phone}</td>
                      <td>{user?.email}</td>
                      <td>{user?.parentAccountNumber}</td>
                      <td>
                        <button
                          className="btn btn-custom startlit_navy btn-sm"
                          onClick={() => setEmailAndPhone(user)}
                        >
                          Select
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        }
      />
    </>
  );
};

export default PhoneSearchPopup;
